import { cva, type VariantProps } from 'class-variance-authority'

export const textVariants = cva('', {
  variants: {
    variant: {
      body: 'font-sans text-sm font-normal text-ink-2 leading-normal tracking-tight',
      lead: 'font-sans text-[17px] font-normal text-ink-2 leading-[1.65] tracking-[-0.005em]',
      prose: 'font-sans text-[15px] font-normal text-ink-2 leading-[1.7] tracking-[-0.005em]',
      reader: 'font-serif text-lg font-normal text-ink-2 leading-relaxed tracking-tight',
      pullquote:
        'font-serif text-[34px] font-normal italic text-ink leading-[1.35] tracking-[-0.02em]',
      ui: 'font-sans text-sm font-medium text-ink leading-[1.4] tracking-[-0.005em]',
      meta: 'font-sans text-[11px] font-normal text-ink-3 leading-snug',
      'mono-xs': 'font-mono text-[10px] font-medium text-ink-3',
    },
  },
  defaultVariants: {
    variant: 'body',
  },
})

export type TextVariantProps = VariantProps<typeof textVariants>
